<template>
<v-card class="elevation-12 sp-combo-form" id="teste" v-if="combo.length > 0">
    <v-card-title class="title">
        <v-btn flat icon @click="close">
                <v-icon color="primary">close</v-icon>
        </v-btn>
        {{product.productname}}
    </v-card-title>
    <v-card-text style="height: 5000px;" class="pt-0" :id="'comboes'+product.code">
        <template
            v-for="(c,i) in combo"
        >   
            <v-list
                v-if="product.combosession_list[i].selection_type=='UNIQUE_SELECT'"
                :key="product.combosession_list[i].display_order"
                :id="`c${i}p${product.code}`"
                subheader
            >
                    <v-radio-group v-model="c.product_list" hide-details @change="uniqueChange(i)"
                    >
                    <v-subheader class="title black--text">
                        {{ product.combosession_list[i].title }}
                        <span class="error--text ml-2 body-2" v-if="!c.ok&&showErrors">Escolha pelo menos 1</span>
                    </v-subheader>
                    <template  v-for="item in product.combosession_list[i].product_list_data">
                        <v-card flat :key="item.code">
                            <v-card-text class="py-1">
                                <v-layout row align-center>
                                    <v-flex xs11>
                                        <span class="subheading">{{item.productname}}</span>
                                        <span class="grey--text body-1" v-if="item.price > 0">
                                        <br>
                                        R${{price(item.price)}}
                                        </span>
                                    </v-flex>
                                    <v-flex xs1>
                                        <v-radio
                                            :value="radioProduct(item,i)"
                                            color="primary"
                                        ></v-radio>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                        <v-divider :key="'a'+item.code"></v-divider>
                    </template>
                    </v-radio-group>
            </v-list>
            <template v-if="product.combosession_list[i].selection_type=='MANY_SELECT'">
                <v-list
                subheader
                :key="product.combosession_list[i].display_order"
                :id="`c${i}p${product.code}`"
                >
                    <v-subheader class="title black--text">
                        {{product.combosession_list[i].title}}
                        <span class="error--text ml-2 body-2" v-if="!c.ok&&showErrors&&c.min_itens>0">
                            Escolha pelo menos {{c.min_itens}}
                        </span>
                    </v-subheader>
                    <span class="ml-3" v-if="qtdGeral(c)>0">
                        {{`Escolhendo ${qtdGeral(c)} `}}
                        <span v-if="c.max_itens < 99">{{`de ${c.max_itens}`}}</span>
                    </span>
                    <template  v-for="(item,index) in c.product_list">
                        <v-card flat :key="item.code">
                            <v-card-text class="py-1">
                                <v-layout row align-end>
                                    <v-flex xs11>
                                        <span class="subheading">{{item.productname}}</span>
                                        <span class="grey--text body-1" v-if="item.price > 0">
                                        <br>
                                        R${{price(item.price)}}
                                        </span>
                                    </v-flex>
                                    <v-flex xs1>
                                        <v-checkbox
                                            hide-details
                                            :disabled="c.block && !item.isSelected"
                                            color="primary"
                                            :error="!c.ok&&showErrors"
                                            v-model="item.isSelected"
                                            @change="qtdAdd(index,i)"
                                        ></v-checkbox>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    <v-divider :key="'a'+item.code"></v-divider>
                    </template>
                </v-list>
            </template>
            <template v-if="product.combosession_list[i].selection_type=='MANY_QTD_SELECT'">
                <v-list
                subheader
                :key="product.combosession_list[i].display_order"
                :id="`c${i}p${product.code}`"
                >
                    <v-subheader class="title black--text">
                        {{product.combosession_list[i].title}}
                    </v-subheader>
                    <span class="ml-3" v-if="qtdGeral(c)>0">
                        {{`Escolhendo ${qtdGeral(c)} `}}
                        <span v-if="c.max_itens < 99">{{`de ${c.max_itens}`}}</span>
                    </span>
                    <span class="error--text ml-3 body-2" v-if="!c.ok&&showErrors&&c.min_itens>0">
                        Escolha pelo menos {{c.min_itens}}
                    </span>
                    <template  v-for="(item,index) in c.product_list">
                        <v-card flat :key="item.code">
                            <v-card-text class="py-1">
                                <v-layout row align-center>
                                    <v-flex xs8 md10>
                                        <span class="subheading">{{item.productname}}</span>
                                        <span class="grey--text body-1" v-if="item.price > 0">
                                        <br>
                                        R${{price(item.price)}}
                                        </span>
                                    </v-flex>
                                    <v-flex xs4 md2>
                                        <v-card-actions>
                                            <v-btn icon outline color="error" small @click="changeValue(i,index,-1)"
                                                :disabled="item.blockRemove"
                                            >
                                                <v-icon>remove</v-icon>
                                            </v-btn>
                                            <span class="mx-2">{{item.qtd}}</span>
                                            <v-btn icon outline color="success" small @click="changeValue(i,index,+1)"
                                                :disabled="item.blockAdd || c.block"
                                            >
                                                <v-icon>add</v-icon>
                                            </v-btn>
                                        </v-card-actions>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                        <v-divider :key="'a'+item.code"></v-divider>
                    </template>
                </v-list>
            </template>
        </template>
    </v-card-text>
    <v-card-actions>
        <v-flex><v-btn color="success" large round block
            @click="add"
        >{{$t('combo.action')}}</v-btn></v-flex>
    </v-card-actions>
</v-card>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    props:['product','toggle'],
    data(){
        return{
            combo:[],
            showErrors:false
        }
    },
    mounted(){
        this.initCombo()
    },
    methods:{
        goTo(combo){
            let {code} = this.product
            this.$vuetify.goTo(`#c${combo}p${code}`,
                {
                    container:`#comboes${code}`,
                    offset:140
                })
        },
        close(){
            this.$vuetify.goTo(0,{container:"#comboes"+this.product.code})
            this.initCombo()
            this.toggle()
        },
        initCombo(){
            this.showErrors=false
            this.combo=[]
            this.product.combosession_list.forEach((c)=>{
                let data = {
                    combosession_id:c._id,
                    selection_type:c.selection_type,
                    max_itens:c.max_itens,
                    max_itens_additions:c.max_itens_additions,
                    max_total_products:(c.max_total_products!=0)?c.max_total_products:-1,
                    min_itens:c.min_itens,
                    block:false,
                    ok:c.min_itens==0
                }
                if(c.selection_type!='UNIQUE_SELECT'){
                    let p_list = JSON.parse(JSON.stringify(c.product_list_data))
                    data.product_list=p_list.map((p)=>{
                            p.isSelected = false
                            p.qtd=0
                            p.qtdItem=0
                            if(c.selection_type=='MANY_QTD_SELECT'){
                                p.blockAdd = false
                                p.blockRemove = true
                            }
                            return p
                    })
                }else{
                    data.product_list=[{}]
                }
                this.combo.push(data)
            })
        },
        qtdGeral(c){
            return c.product_list.reduce((acc,cur)=>acc+=cur.qtd,0)//==c.max_total_products
        },
        qtdProdutosCombo(c){
            return c.product_list.reduce((acc,cur)=>(cur.qtd>0)?acc+=1:acc,0)//==c.max_itens
        },
        uniqueChange(i){
            this.combo[i].ok=true
            if(i<this.combo.length)
                this.goTo(i+1)
        },
        qtdAdd(index,i){
            let item = this.combo[i].product_list[index]
            if(item.isSelected)
                item.qtd = 1
            else
                item.qtd = 0
            if(this.qtdProdutosCombo(this.combo[i])>=this.combo[i].min_itens){
                this.combo[i].ok = true
            }else{
                this.combo[i].ok = false
            }
            this.combo[i].block=this.qtdProdutosCombo(this.combo[i])==this.combo[i].max_itens
            if(this.combo[i].block && i<this.combo.length)
                this.goTo(i+1)
        },
        price(v){
            return Number(v).toFixed(2).toString().replace('.',',')
        },
        changeValue(i,index,value){
            let item = this.combo[i].product_list[index]
            item.qtd += value
            item.isSelected = true
            this.combo[i].product_list.splice(index,1,item)

            item.blockAdd = item.qtd == this.combo[i].max_itens_additions
            item.blockRemove = item.qtd == 0
            if(this.qtdGeral(this.combo[i])>=this.combo[i].min_itens){
                this.combo[i].ok = true
            }else{
                this.combo[i].ok = false
            }
            this.combo[i].block=this.qtdProdutosCombo(this.combo[i])==this.combo[i].max_itens
                || this.qtdGeral(this.combo[i])==this.combo[i].max_total_products
            if(this.combo[i].block && i<this.combo.length)
                this.goTo(i+1)

        },
        radioProduct(item,i){
            item.isSelected = true
            item.qtd = 1
            return [item]
        },
        add(){
            if(this.combo.reduce((acc,cur)=>acc=acc&&cur.ok,true)){
                this.$vuetify.goTo(0,{container:"#comboes"+this.product.code})
                this.$store.dispatch('addProductToCart',{payload:this.product,q:1,combo:this.combo}).then(_=>{
                    this.initCombo()
                    if(this.$vuetify.breakpoint.xsOnly)
                        this.$router.push({name:'Cart'})
                    else
                        this.toggle()
                })
            }else{
                this.showErrors=true
                let go = this.combo.findIndex(c=>!c.ok)
                this.goTo(go)
            }
            
        }
    }

}
</script>

<style lang="scss">
    .sp-combo-form{
        .v-input__control{
            width: 100% !important
        }
    }
</style>

